export const quoteList = [
    "어두운 밤이 지나면 아침이 옵니다.",
    "지금 이 순간도 결국 지나갈 거예요.",
    "잠시 힘들어도, 이 모든 것이 지나가면 좋은 일이 있을 거예요.",
    "당신의 소중함을 잊지 마세요.",
    "힘든 시기를 견뎌내는 것이 결국 당신을 더 강하게 만들 거예요.",
    "당신은 충분히 잘하고 있어요.",
    "사랑하는 사람들과 함께하면, 어떤 고난도 이겨낼 수 있어요.",
    "당신이 얼마나 소중한지 기억하세요.",
    "당신은 언제나 좋은 일을 만날 자격이 있어요.",
    "힘들 때에도 웃음을 잃지 마세요.",
    "당신의 꿈을 위해 포기하지 말아요.",
    "지금 당장은 힘들어도, 더 나은 내일을 위해 힘을 내요.",
    "오늘 하루도 잘 견뎌냈다고 스스로에게 칭찬해주세요.",
    "당신이 겪는 어려움을 이겨내는 것은 결국 더 나은 미래를 위한 것이에요.",
    "당신은 누군가에게 세상을 바꾸는 영감이 될 수 있어요.",
    "어떤 상황에서도 희망을 잃지 말아요.",
    "당신에게는 많은 사람들이 응원하고 있어요.",
    "당신의 삶은 소중하고 의미 있어요.",
    "지친 당신, 한 숨 쉬어도 돼요.",
    "조금씩 나아지는 건 느리지만, 그래도 진행되고 있어요.",
    "지친 하루 끝에, 기분 좋은 노래로 마음을 풀어보세요.",
    "오늘 하루는 힘들었겠지만, 내일은 더 나은 하루가 될 거예요.",
    "어떤 상황에서도, 당신은 괜찮아요.",
    "밤하늘의 별들처럼, 당신도 빛날 순 있어요.",
    "가끔은 마음을 비우고, 쉬어가는 건 어때요?",
    "마음의 여유를 갖기 위해, 조용한 음악을 들어보세요.",
    "힘든 일을 겪고 있을 땐, 조금씩 나아지기 위한 작은 걸 하나씩 해보세요.",
    "당신의 인내와 노력은 결국 보상받게 될 거예요.",
    "모든 일은 한번쯤은 끝이 있죠. 이 어려움도 끝이 날 거예요.",
    "자신감을 가져보세요. 당신은 할 수 있어요.",
    "마음이 아프면 슬퍼해도 돼요. 슬픔도 언젠가는 사라질 거예요.",
    "당신의 노력은 모두 인정받을 만한 가치가 있어요.",
]